// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607290247/js/" + chunkId + "." + {"44":"8fe1a578","225":"64bd9d32","481":"a685be05","486":"69853133","770":"ea83f005"}[chunkId] + ".0.5045242742498814.chunk.js";
};